<template>
    <div class="msg">
        <div class="phonePreBox">
            <div class="phone-title" v-text="phoneTitle"></div>
            <div class="phone-list-box">
                <div class="phone-list" v-for="(item,key,index) in list" :key="index">
                    <div class="list-header" v-text="key"></div>
                    <ul v-for="(items,keys,indexs) in item" :key="indexs">
                        <li class="list-cont" :class="{'list-line':indexs<Object.keys(item).length-1}">
                            <input @click="select(items)" class="checkRadio" :checked="items===choice" type="radio" :name="name">
                            <span v-text="keys+' ('+items+')'"></span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="btn-box cle">
                <button type="button" class="fl" :title="confirmText" v-text="confirmText" @click="confirm"></button>
                <button type="button" class="fr" :title="cancleText" v-text="cancleText" @click="cancle"></button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'PhonePre',
    data(){
        return {
            list:{
                A:{
                    'Afghanistan':'+93',
                    'Albania':'+355',
                    'Algeria':'+213',
                    'Andorra':'+376',
                    'Angola':'+244',
                    'Anguilla':'+1264',
                    'Antigua and Barbuda':'+1268',
                    'Argentina':'+54',
                    'Ascension':'+247',
                    'Australia':'+61',
                    'Austria':'+43',
                    'Azerbaijan':'+994'
                },
                B:{
                    'Bahamas':'+1242',
                    'Bahrain':'+973',
                    'Bangladesh':'+880',
                    'Barbados':'+1246',
                    'Belarus':'+375',
                    'Belgium':'+32',
                    'Belize':'+501',
                    'Benin':'+229',
                    'Bermuda Is.':'+1441',
                    'Bolivia':'+591',
                    'Botswana':'+267',
                    'Brazil':'+55',
                    'Brunei':'+673',
                    'Bulgaria':'+359',
                    'Burkina Faso':'+226',
                    'Burma':'+95',
                    'Burundi':'+257'
                },
                C:{
                    'Cameroon':'+237',
                    'Canada':'+1',
                    'Cayman Is.':'+1345',
                    'Central African Republic':'+236',
                    'Chad':'+235',
                    'Chile':'+56',
                    'China':'+86',
                    'Colombia':'+57',
                    'Congo':'+242',
                    'Cook Is':'+682',
                    'Costa Rica':'+506',
                    'Cuba':'+53',
                    'Cyprus':'+357',
                    'Czech Republic':'+420'
                },
                D:{
                    'Denmark':'+45',
                    'Djibouti':'+253'
                },
                E:{
                    'Ecuador':'+593',
                    'Egypt':'+20',
                    'El Salvador':'+503',
                    'Estonia':'+372',
                    'Ethiopia':'+251'
                },
                F:{
                    'Fiji':'+679',
                    'Finland':'+358',
                    'France':'+33',
                    'French Guiana':'+594',
                    'French Polynesia':'+689'
                },
                G:{
                    'Gabon':'+241',
                    'Gambia':'+220',
                    'Georgia':'+995',
                    'Germany':'+49',
                    'Ghana':'+233',
                    'Gibraltar':'+350',
                    'Greece':'+30',
                    'Grenada':'+1809',
                    'Guam':'+1671',
                    'Guatemala':'+502',
                    'Guinea':'+224',
                    'Guyana':'+592'
                },
                H:{
                    'Haiti':'+509',
                    'Honduras':'+504',
                    'Hong Kong':'+852',
                    'Hungary':'+36'
                },
                I:{
                    'Iceland':'+354',
                    'India':'+91',
                    'Iran':'+98',
                    'Iraq':'+964',
                    'Iceland':'+354',
                    'Ireland':'+353',
                    'Israel':'+972',
                    'Italy':'+39',
                    'Ivory Coast':'+225'
                },
                J:{
                    'Jamaica':'+1876',
                    'Japan':'+81',
                    'Jordan':'+962'
                },
                K:{
                    'Kampuchea (Cambodia)':'+855',
                    'Kazakstan':'+327',
                    'Kenya':'+254',
                    'Korea':'+82',
                    'Kuwait':'+965',
                    'Kyrgyzstan':'+331'
                },
                L:{
                    'Laos':'+856',
                    'Latvia':'+371',
                    'Lebanon':'+961',
                    'Lesotho':'+266',
                    'Liberia':'+231',
                    'Libya':'+218',
                    'Liechtenstein':'+423',
                    'Lithuania':'+370',
                    'Luxembourg':'+352'
                },
                M:{
                    'Macao':'+853',
                    'Madagascar':'+261',
                    'Malawi':'+265',
                    'Malaysia':'+60',
                    'Maldives':'+960',
                    'Mali':'+223',
                    'Malta':'+356',
                    'Mariana Is':'+1670',
                    'Martinique':'+596',
                    'Mauritius':'+230',
                    'Mexico':'+52',
                    'Monaco':'+377',
                    'Mongolia':'+976',
                    'Montserrat Is':'+1664',
                    'Morocco':'+212',
                    'Mozambique':'+258'
                },
                N:{
                    'Namibia':'+264',
                    'Nauru':'+674',
                    'Nepal':'+977',
                    'Netherlands Antilles':'+599',
                    'Netherlands':'+31',
                    'New Zealand':'+64',
                    'Nicaragua':'+505',
                    'Niger':'+227',
                    'Nigeria':'+234',
                    'North Korea':'+850',
                    'Norway':'+47'
                },
                O:{
                    'Oman':'+968'
                },
                P:{
                    'Pakistan':'+92',
                    'Panama':'+507',
                    'Papua New Guinea':'+675',
                    'Paraguay':'+595',
                    'Peru':'+51',
                    'Philippines':'+63',
                    'Poland':'+48',
                    'Portugal':'+351',
                    'Puerto Rico':'+1787'
                },
                Q:{
                    'Qatar':'+974'
                },
                R:{
                    'Republic of Moldova':'+373',
                    'Reunion':'+262',
                    'Romania':'+40',
                    'Russia':'+7'
                },
                S:{
                    'Saint Lucia':'+1758',
                    'Saint Vincent':'+1784',
                    'Samoa Eastern':'+684',
                    'Samoa Western':'+685','Republic of Moldova':'+373',
                    'San Marino':'+378',
                    'Sao Tome and Principe':'+239',
                    'Saudi Arabia':'+966',
                    'Senegal':'+221',
                    'Seychelles':'+248',
                    'Sierra Leone':'+232',
                    'Singapore':'+65',
                    'Slovakia':'+421',
                    'Slovenia':'+386',
                    'Solomon Is':'+677',
                    'Somali':'+252',
                    'South Africa':'+27',
                    'Spain':'+34',
                    'Sri Lanka':'+94',
                    'St.Lucia':'+1758',
                    'St.Vincent':'+1784',
                    'Sudan':'+249',
                    'Suriname':'+597',
                    'Swaziland':'+268',
                    'Sweden':'+46',
                    'Switzerland':'+41',
                    'Syria':'+963'
                },
                T:{
                    'Taiwan':'+886',
                    'Tajikstan':'+992',
                    'Tanzania':'+255',
                    'Thailand':'+66',
                    'The Dominican Republic':'+1890',
                    'Togo':'+228',
                    'Tonga':'+676',
                    'Trinidad and Tobago':'+1809',
                    'Tunisia':'+216',
                    'Turkey':'+90',
                    'Turkmenistan':'+993'
                },
                U:{
                    'Uganda':'+256',
                    'Ukraine':'+380',
                    'United Arab Emirates':'+971',
                    'United Kingdom':'+44',
                    'United States Of America':'+1',
                    'Uruguay':'+598',
                    'Uzbekistan':'+233'
                },
                V:{
                    'Venezuela':'+58',
                    'Vietnam':'+84'
                },
                Y:{
                    'Yemen':'+967',
                    'Yugoslavia':'+381'
                },
                Z:{
                    'Zaire':'+243',
                    'Zambia':'+260',
                    'Zimbabwe':'+263'
                }
            },
            allWord:[],
            choice:'+86',
            name:'',
            phoneTitle:'',
            confirmText:'',
            cancleText:''
        }
    },
    mounted:function(){
        this.name='PhonePre'+Math.floor(Math.random()*100);
        for (let i = 65; i <= 90; i++) {
            this.allWord.push(String.fromCharCode(i));
        };
    },
    methods:{
        select:function(pre){
            this.choice=pre;
        },
        confirm:function(){
            this.$emit('show',{show:true,num:this.choice});
        },
        cancle:function(){
            this.$emit('show',{show:false,num:this.choice});
        },
        lang:function(lan){
            var lang=this.lanSave[lan];
            this.phoneTitle=lang['K150_PhoneCode'];
            this.confirmText =lang['K024_Confirm'];
            this.cancleText =lang['K018_Cancel'];
        }
    }
}
</script>
<style scoped>
    .msg{
        position:fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background-color:rgba(0, 0, 0, .5);
        z-index: 3;
    }
    .phonePreBox{
        width:400px;
        height:500px;
        background-color:#fff;
        margin-top:-250px;
        margin-left:-200px;
        position:absolute;
        top:50%;
        left:50%;
        /* color: #fff; */
    }
    .phone-title{
        width:100%;
        height:24px;
        line-height:24px;
        text-align: center;
        font-size: 16px;
    }
    .phone-list-box{
        width:100%;
        height:calc(100% - 140px);
        margin-top:20px;
        padding: 0 20px;
        box-sizing: border-box;
        overflow: hidden;
        overflow-y:auto;
    }
    .list-header{
        width:100%;
        height:30px;
        line-height: 30px;
        background-color: #ccc;
    }
    .list-cont{
        width:100%;
        height:30px;
        line-height: 30px;
    }
    .list-line{
        border-bottom:1px solid #ccc;
    }
    .checkRadio{
        margin:0;
        vertical-align: middle;
        margin-right: 5px;
    }
    .btn-box{
        width:200px;
        height:30px;
        margin:0 auto;
        margin-top:30px;
    }
    .btn-box button{
        width:80px;
        height:100%;
        border:none;
        outline: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/PhonePre.vue